import type { ActionConfig } from './types';
import { workorderCreateRoute } from './workorderCreateRoute';

export const serviceLogActions: ActionConfig[] = [
  // =============================================================================
  // RECORD ACTIONS
  // =============================================================================
  {
    id: 'slog-edit',
    name: 'Edit',
    icon: 'edit',
    table: 'serviceLogs',
    type: 'EDIT_RECORD',
    prominence: 'prominent',
    order: 1,
    condition: (row, user) =>
      user.viewTags.includes('Management Views') || row.employeeEmail === user.email,
    config: {},
  },
  {
    id: 'slog-add',
    name: 'Add',
    icon: 'plus',
    table: 'serviceLogs',
    type: 'ADD_RECORD',
    prominence: 'prominent',
    order: 2,
    config: {},
  },
  {
    id: 'slog-delete',
    name: 'Delete',
    icon: 'trash',
    table: 'serviceLogs',
    type: 'DELETE_RECORD',
    prominence: 'menu',
    order: 99,
    needsConfirmation: true,
    confirmationMessage: 'Are you sure you want to delete this service log?',
    config: {},
  },

  // =============================================================================
  // NAVIGATION ACTIONS
  // =============================================================================
  {
    id: 'slog-view-map',
    name: 'View Map (LatLong)',
    icon: 'map-marker',
    table: 'serviceLogs',
    type: 'NAVIGATE_APP',
    prominence: 'inline',
    order: 10,
    condition: (row) => Boolean(row.latLong),
    config: {
      route: '/service-logs/:key/map',
      params: { key: 'key' },
    },
  },
  {
    id: 'slog-view-client',
    name: 'View Client',
    icon: 'chevron-circle-right',
    table: 'serviceLogs',
    type: 'NAVIGATE_APP',
    prominence: 'inline',
    order: 11,
    condition: (row) => Boolean(row.clientId),
    config: {
      route: '/clients/:clientId',
      params: { clientId: 'clientId' },
    },
  },
  {
    id: 'slog-create-workorder',
    name: 'Create Workorder',
    icon: 'plus',
    table: 'serviceLogs',
    type: 'NAVIGATE_APP',
    prominence: 'prominent',
    order: 12,
    config: {
      route: (row: Record<string, unknown>) => workorderCreateRoute(row.clientId),
    },
  },
  {
    id: 'slog-request-qa',
    name: 'Request QA',
    icon: 'clipboard-check',
    table: 'serviceLogs',
    type: 'NAVIGATE_APP',
    prominence: 'menu',
    order: 20,
    condition: (row) => {
      // Show for aging or missed service logs
      const ageDays = Number(row.ageDays) || 0;
      const missedService = Boolean(row.missedService);
      return ageDays > 30 || missedService;
    },
    config: {
      route: '/requests/new',
      params: { type: 'qa', client: 'clientId' },
    },
  },

  // =============================================================================
  // EXPORT ACTIONS
  // =============================================================================
  {
    id: 'slog-download',
    name: 'Download',
    icon: 'download',
    table: 'serviceLogs',
    type: 'EXPORT_VIEW',
    prominence: 'menu',
    order: 50,
    config: {},
  },
];
